import { Link, type LinkProps } from 'react-router-dom';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '../../utils/cn';

type Variant = 'primary' | 'secondary' | 'ghost';

const variants: Record<Variant, string> = {
  primary: 'bg-brand-700 text-white hover:bg-brand-900 shadow-soft',
  secondary: 'bg-white text-brand-900 ring-1 ring-brand-100 hover:bg-brand-50',
  ghost: 'bg-transparent text-brand-900 hover:bg-brand-50',
};

type BaseProps = {
  children: ReactNode;
  variant?: Variant;
  className?: string;
};

export function Button({ children, variant = 'primary', className, ...props }: BaseProps & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      className={cn(
        'inline-flex min-h-11 items-center justify-center gap-2 rounded-md px-5 py-3 text-sm font-semibold transition',
        variants[variant],
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}

export function ButtonLink({ children, variant = 'primary', className, ...props }: BaseProps & LinkProps) {
  return (
    <Link
      className={cn(
        'inline-flex min-h-11 items-center justify-center gap-2 rounded-md px-5 py-3 text-sm font-semibold transition',
        variants[variant],
        className,
      )}
      {...props}
    >
      {children}
    </Link>
  );
}
